export const IndividualAndFamilyLife = {
  "label": "Individual And Family Life",
  "value": [
    {
      "code": "P",
      "keyword": "Individual and Family Life"
    },
    {
      "code": "PN-8100.4500-550",
      "keyword": "Military Family Support Groups"
    },
    {
      "code": "PH",
      "keyword": "Individual and Family Support Services"
    },
    {
      "code": "PH-0300",
      "keyword": "Adoption Services"
    },
    {
      "code": "PH-0320",
      "keyword": "Adult Day Programs"
    },
    {
      "code": "PH-0700",
      "keyword": "Benefits Screening"
    },
    {
      "code": "PH-1000",
      "keyword": "Case\/Care Management"
    },
    {
      "code": "PH-1250.1400",
      "keyword": "Child Care Centers"
    },
    {
      "code": "PH-1250.1800",
      "keyword": "Extended Child Care"
    },
    {
      "code": "PH-1400.1900-230",
      "keyword": "Friendly Visiting"
    },
    {
      "code": "PH-1400.5000",
      "keyword": "Mentoring Programs"
    },
    {
      "code": "PH-1800.3300",
      "keyword": "Identification Devices"
    },
    {
      "code": "PH-1800.5000",
      "keyword": "Medic Alert"
    },
    {
      "code": "PH-1800.8500",
      "keyword": "Telephone Reassurance"
    },
    {
      "code": "PH-2360.2400",
      "keyword": "Family Support Centers\/Outreach"
    },
    {
      "code": "PH-2400.1500",
      "keyword": "Child Care Provider Referrals"
    },
    {
      "code": "PH-2400.4000",
      "keyword": "Kinship Navigator Programs"
    },
    {
      "code": "PH-2950.1500",
      "keyword": "Christmas Programs"
    },
    {
      "code": "PH-2950.8500",
      "keyword": "Thanksgiving Programs"
    },
    {
      "code": "PH-3300.1800",
      "keyword": "Errand Running\/Shopping Assistance"
    },
    {
      "code": "PH-3300.2740",
      "keyword": "Home Maintenance and Minor Repair Grants\/Loans"
    },
    {
      "code": "PH-3300.2750",
      "keyword": "Home Maintenance and Minor Repair Services"
    },
    {
      "code": "PH-3300.3000",
      "keyword": "Homemaker Assistance"
    },
    {
      "code": "PH-3300.3100-300",
      "keyword": "Housekeeping Services"
    },
    {
      "code": "PH-3300.8030",
      "keyword": "Supported Living Services for Adults With Disabilities"
    },
    {
      "code": "PH-3300.9750",
      "keyword": "Yard Maintenance"
    },
    {
      "code": "PH-3300.9750-765",
      "keyword": "Residential Tree Removal"
    },
    {
      "code": "PH-3500",
      "keyword": "Interpretation\/Translation"
    },
    {
      "code": "PH-3500.4500",
      "keyword": "Language Interpretation"
    },
    {
      "code": "PH-3500.8000",
      "keyword": "Sign Language Interpretation"
    },
    {
      "code": "PH-3500.8500",
      "keyword": "Telecommunication Relay Services"
    },
    {
      "code": "PH-5800",
      "keyword": "Neighborhood Welcoming Services"
    },
    {
      "code": "PH-6000",
      "keyword": "Parental Visitation Facilitation"
    },
    {
      "code": "PH-6100",
      "keyword": "Parenting Education"
    },
    {
      "code": "PH-6100.6600",
      "keyword": "Parenting Helplines"
    },
    {
      "code": "LR-1550",
      "keyword": "Centers for Independent Living"
    },
    {
      "code": "LR-3200",
      "keyword": "Independent Living Skills Instruction"
    },
    {
      "code": "RP-1400.8000-020.03",
      "keyword": "Adult Child Abuse Survivor Counseling"
    },
    {
      "code": "RP-1400.8000-020.15",
      "keyword": "Child Abuse Counseling"
    },
    {
      "code": "RP-1400.8000-020.24",
      "keyword": "Elder Abuse Counseling"
    },
    {
      "code": "RP-1400.8000-020.80",
      "keyword": "Spouse\/Intimate Partner Abuse Counseling"
    },
    {
      "code": "RP-1400.8000-050",
      "keyword": "Adolescent\/Youth Counseling"
    },
    {
      "code": "RP-1400.8000-070",
      "keyword": "Anger Management"
    },
    {
      "code": "RP-1400.8000-100",
      "keyword": "Bereavement and Grief Counseling"
    },
    {
      "code": "RP-1400.8000-120",
      "keyword": "Bullying Counseling"
    },
    {
      "code": "RP-1400.8000-145",
      "keyword": "Caregiver Counseling"
    },
    {
      "code": "RP-1400.8000-175",
      "keyword": "Divorce Counseling"
    },
    {
      "code": "RP-1400.8000-200",
      "keyword": "First Responder Trauma Counseling"
    },
    {
      "code": "RP-1400.8000-250",
      "keyword": "Gambling Addiction Counseling"
    },
    {
      "code": "RP-1400.8000-315",
      "keyword": "Hoarding Counseling Programs"
    },
    {
      "code": "RP-1400.8000-327",
      "keyword": "Human Trafficking Counseling"
    },
    {
      "code": "RP-1400.8000-500",
      "keyword": "Marriage Counseling"
    },
    {
      "code": "RP-1400.8000-650",
      "keyword": "Parent Counseling"
    },
    {
      "code": "RP-1400.8000-655",
      "keyword": "Perinatal Mood and Anxiety Disorders Treatment"
    },
    {
      "code": "RP-1400.8000-660",
      "keyword": "Postabortion Counseling"
    },
    {
      "code": "RP-1400.8000-800",
      "keyword": "Sexual Assault Counseling"
    },
    {
      "code": "RP-1400.8000-825",
      "keyword": "Suicide Counseling"
    },
    {
      "code": "RP-1400.8000-900",
      "keyword": "Veteran Reintegration Counseling"
    },
    {
      "code": "RP-1500.1400",
      "keyword": "Crisis Intervention Hotlines\/Helplines"
    },
    {
      "code": "RD-1900",
      "keyword": "Faith Based Counseling"
    },
    {
      "code": "RD-8500",
      "keyword": "Trauma Focused Cognitive Behavioral Therapy"
    },
    {
      "code": "RF-2000",
      "keyword": "Family Counseling"
    },
    {
      "code": "RF-2500",
      "keyword": "Group Counseling"
    },
    {
      "code": "RF-3300",
      "keyword": "Individual Counseling"
    },
    {
      "code": "RF-8380",
      "keyword": "Talklines\/Warmlines"
    },
    {
      "code": "YJ-2075.1500",
      "keyword": "Children of Abused Women\/Men"
    },
    {
      "code": "YJ-4840.0500",
      "keyword": "Adult Children of Parents With an Alcohol Use Disorder"
    },
    {
      "code": "YJ-4840.1500",
      "keyword": "Children of Individuals With an Alcohol Use Disorder"
    },
    {
      "code": "YJ-4840.8000",
      "keyword": "Siblings of Individuals With an Alcohol Use Disorder"
    },
    {
      "code": "YJ-4840.8200",
      "keyword": "Spouses\/Intimate Partners of Individuals With an Alcohol Use Disorder"
    },
    {
      "code": "YJ-4850",
      "keyword": "Families\/Friends of Individuals With a Drug Use Disorder"
    },
    {
      "code": "YJ-4850.1500",
      "keyword": "Children of Individuals With a Drug Use Disorder"
    },
    {
      "code": "YJ-4850.8200",
      "keyword": "Spouses\/Intimate Partners of Individuals With a Drug Use Disorder"
    },
    {
      "code": "YJ-5000.1500",
      "keyword": "Children of Inmates\/Ex-Offenders"
    },
    {
      "code": "YJ-5065",
      "keyword": "Families\/Friends of LGBTQ2+ Individuals"
    },
    {
      "code": "YJ-6830.0270",
      "keyword": "Families\/Friends of People With AIDS\/HIV"
    },
    {
      "code": "YJ-6830.0440",
      "keyword": "Families\/Friends of People With Alzheimer's Disease and Other Dementias"
    },
    {
      "code": "YJ-6830.1480",
      "keyword": "Families\/Friends of People With Cancer"
    },
    {
      "code": "YJ-8745",
      "keyword": "People With Complex Needs"
    },
    {
      "code": "YJ-8750.9000",
      "keyword": "Veterans With Disabilities"
    },
    {
      "code": "YJ-9300",
      "keyword": "Transition Age Youth"
    },
    {
      "code": "YK-2000",
      "keyword": "Families"
    },
    {
      "code": "YK-6500.1900",
      "keyword": "Fathers"
    },
    {
      "code": "YK-6500.8000-800",
      "keyword": "Single Fathers"
    },
    {
      "code": "YK-6500.8000-830",
      "keyword": "Single Mothers"
    },
    {
      "code": "YN-0500",
      "keyword": "Active Military"
    },
    {
      "code": "YN-7000",
      "keyword": "Retired Military"
    },
    {
      "code": "YN-9000",
      "keyword": "Veterans"
    },
    {
      "code": "YO-0200",
      "keyword": "Agricultural\/Forestry and Related Occupations"
    },
    {
      "code": "YO-0200.0250",
      "keyword": "Agricultural Laborers"
    },
    {
      "code": "YO-1550.8990",
      "keyword": "Veteran Service Officers"
    },
    {
      "code": "YO-5000.1300",
      "keyword": "Certified Peer Specialists"
    },
    {
      "code": "YS-8500",
      "keyword": "Transgender Individuals"
    },
    {
      "code": "YT-2400",
      "keyword": "LGBTQ2+ Individuals"
    },
    {
      "code": "YT-2400.4550",
      "keyword": "LGBTQ2+ Youth"
    },
    {
      "code": "YV-3000",
      "keyword": "Homeless People"
    },
    {
      "code": "YW-7000",
      "keyword": "Rural Residents"
    },
    {
      "code": "YX-0300.0185",
      "keyword": "Abused Transgender Individuals"
    },
    {
      "code": "YX-0300.0190",
      "keyword": "Abused Women"
    },
    {
      "code": "YX-0300.8100-030",
      "keyword": "Adult Incest Survivors"
    },
    {
      "code": "YX-0500.1400",
      "keyword": "Children Abused in Residential\/Institutional Settings"
    },
    {
      "code": "YX-0500.6400",
      "keyword": "Physically Abused Children"
    },
    {
      "code": "YX-1100",
      "keyword": "Bullying Victims"
    },
    {
      "code": "YZ-0310",
      "keyword": "After School\/Summer Program Issues"
    },
    {
      "code": "YZ-1560",
      "keyword": "COVID-19 Issues"
    },
    {
      "code": "YZ-2575",
      "keyword": "Grief and Loss Issues"
    },
    {
      "code": "YZ-3400",
      "keyword": "Infant Mortality Issues"
    },
    {
      "code": "YZ-4530",
      "keyword": "LGBTQ2+ Issues"
    },
    {
      "code": "YZ-6180",
      "keyword": "Parental Visitation Issues"
    },
    {
      "code": "YZ-8420",
      "keyword": "Suicide Issues"
    },
  ]
}
